import { useMemo } from "react";
import { useSelector } from "../store";
var useCBookTheme = function() {
    var themeCapabilities = useSelector(function(state) {
        var _state_cbook;
        return (_state_cbook = state.cbook) === null || _state_cbook === void 0 ? void 0 : _state_cbook.theme_capabilities;
    });
    var isAccessibleTheme = useMemo(function() {
        return Boolean(themeCapabilities === null || themeCapabilities === void 0 ? void 0 : themeCapabilities.includes("accessibility"));
    }, [
        themeCapabilities
    ]);
    var hasColorMode = useMemo(function() {
        return Boolean(themeCapabilities === null || themeCapabilities === void 0 ? void 0 : themeCapabilities.includes("color_mode"));
    }, [
        themeCapabilities
    ]);
    return {
        isAccessibleTheme: isAccessibleTheme,
        hasColorMode: hasColorMode
    };
};
export default useCBookTheme;
